export default class BookingStatus {
  isBooking: boolean = false;
  bookingUrl: string = "";
}

export {
  BookingStatus
};